export const JWT_TOKEN = 'JWT_TOKEN'
export const PERFIL_LOGADO = 'PERFIL_LOGADO'
export const USUARIO_LOGADO = 'USUARIO_LOGADO'
